module.exports = __webpack_public_path__ + "img/teaser_training4.49194408.jpg";